export function getAuthHeader(user) {
  return {
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${user.token}`
  };
}
